<template>
  <section class="ref-chapter-1">
    <div class="ref-chapter-1-hero hidden-md-and-up">
      <img src="@/assets/solutions/solutions-landing-bg.png" width="100%" />
    </div>

    <div class="ref-chapter-1-content">
      <RefAnchorNav :section="1" />
      
      <v-container  class="px-sm-8 py-0 pa-md-0">
        <v-row align="start" justify="space-between" no-gutters>
          <v-col cols="12" md="3">
            <p class="text-section text--fes-magenta mb-4 mb-md-0">
              List of data sources and references
            </p>
          </v-col>

          <v-col cols="12" md="8">
            <div class="reference-list mb-12">
              <p class="text-card mb-6 text--fes-blue">About and Solutions Page</p>
              <p class="text-body text--fes-blue mb-6" v-for="(ref, i) in refListAboutSolution" :key="ref.item + i">
                {{ ref.item }}
                <a :href="ref.link" target="_blank">{{ ref.link }}</a>.
              </p> 
            </div>

            <div class="reference-list mb-12">
              <p class="text-card mb-6 text--fes-blue">Map Page</p>
              <p class="text-body text--fes-blue mb-6" v-for="(ref, i) in refListMap" :key="'ref-map' + i">
                {{ ref.item }}
                <a :href="ref.link" target="_blank">{{ ref.link }}</a>.
              </p> 
            </div>

            <div v-for="(country, i) in refCountries" :key="i + '-' + country.city">
              <p class="text-card mt-12 mb-6 text--fes-blue">{{ country.city }}</p>
              <p class="text-body text--fes-blue mb-6" v-for="(item, i) in country.list" :key="'item-city' + i">
                {{ item.item }} <a :href="item.link" target="_blank">{{ item.link }}</a>.
              </p>                 
            </div>                   
          </v-col>
        </v-row>
      </v-container>
    </div>      
  </section>  
</template>

<script>
import RefAnchorNav from '@/components/layout/RefAnchorNav'

export default {
  name: 'RefChapter1',
  components: {
    RefAnchorNav
  },
  data() {
    return {
      refListAboutSolution: [
        {
          item: 'Archer, Diane, and Charrlotte Adelina (2020). Social-ecological transformation in cities in Asia. Hanoi: Friedrich-Ebert-Stiftung Vietnam Office; Bangkok: Stockholm Environment Institute Asia.',
          link: 'http://library.fes.de/pdf-files/bueros/vietnam/16975.pdf'
        },
        {
          item:"Asara, Viviana, and others (2015). Socially sustainable degrowth as a social–ecological transformation: Repoliticizing sustainability. Sustainability Science, vol. 10, No. 3 (July).",
          link:"https://doi.org/10.1007/s11625-015-0321-9"          
        },     
        {
          item:"Friedrich-Ebert-Stiftung Asia (n.d.). Friedrich-Ebert-Stiftung: Friedrich-Ebert-Stiftung in Asia.” Accessed September 17, 2021.",
          link:"https://asia.fes.de/about/friedrich-ebert-stiftung"          
        }, 
        {
          item: "Friedrich-Ebert-Stiftung Asia (n.d.). Midas Touch—Turning waste to fuel industry [Ecological resilience (Green urban infrastructure)]. Case study. Accessed on 29 July 2021.",
          link: ''
        },
        {
          item:"Friedrich-Ebert-Stiftung Asia (n.d.). MinusCO2—Distributed solar and clean-tech with retail impact investment (economic resilience). Case study. Accessed on 29 July 2021.",
          link: ''
        },
        {
          item:"FES Climate & Energy Project in Asia (2020). Pathways towards a social-ecological transformation in Asian cities. FES-Asia, 27 October.",
          link: 'https://asia.fes.de/news/pathways-towards-a-social-ecological-transformation-in-asian-cities'
        },  
        {
          item:"Friedrich-Ebert-Stiftung Asia (n.d.). Social-ecological transformation in Asia. Accessed on 17 September 2021.",
          link: 'https://asia.fes.de/our-work/climate-change-energy-and-the-environment'
        },  
        {
          item:"Friedrich-Ebert-Stiftung (n.d.). 6 International climate policies of the Friedrich-Ebert-Stiftung. Accessed on 17 September, 2021.",
          link: 'https://www.fes.de/en/shaping-a-just-world/climate-change-energy-and-environment/international-climate-and-energy-policies'
        },  
        {
          item:"Friedrich-Ebert-Stiftung Global (2021). Social-ecological transformation in Asian cities | FES Asia. YouTube video. 4 August.",
          link: ' https://youtu.be/2IIljNlOpUQ'
        },  
        {
          item:"Fuentes, Ursula, and Anna Chapman (2021). Shifting investment away from fossil fuels in Southeast Asia. Hanoi: FES Vietnam Office.",
          link: 'https://asia.fes.de/news/fossil-fuel-divestment'
        },  
        {
          item:"Fuentes, Ursula, and Anna Chapman (2021). Shifting investment away from fossil fuels in Southeast Asia. Hanoi: FES Vietnam Office.",
          link: 'https://asia.fes.de/news/fossil-fuel-divestment'
        },  
        {
          item:"Harriss, John (2006). Middle-class activism and the politics of the informal working class. Critical Asian Studies vol. 38, No. 4 (December).",
          link: 'https://doi.org/10.1080/14672710601073002'
        },  
        {
          item:"United Nations Economic and Social Commission for Asia and the Pacific (2021). Asia and the Pacific SDG progress report 2021, Bangkok, Thailand.",
          link: 'https://www.unescap.org/sites/default/d8files/knowledge-products/ESCAP_Asia_and_the_Pacific_SDG_Progress_Report_2021.pdf'
        },  
        {
          item:"United Nations HABITAT (n.d.). New urban agenda. Web page. Accessed on 17 September, 2021.",
          link: 'https://unhabitat.org/about-us/new-urban-agenda'
        },  
        {
          item:"United Nations Climate Change (n.d.). The Paris agreement. Web page. Accessed on 17 September, 2021.",
          link: 'https://unfccc.int/process-and-meetings/the-paris-agreement/the-paris-agreement'
        },  
        {
          item:"United Nations Department of Economic and Social Affairs, Sustainable Development (n.d.). Transforming our world: The 2030 agenda for sustainable development, A/RES/70/1. Accessed on 29 July, 2021.",
          link: 'https://sustainabledevelopment.un.org/content/documents/21252030%20Agenda%20for%20Sustainable%20Development%20web.pdf'
        }                                                                                        
      ],
      refListMap: [
        {
          item: '“Advancing Inclusive and Resilient Urban Development Targeted at the Urban Poor Pro-Poor Climate Change Adaptation for Urban Areas.” Asian Development Bank, September 2020.',
          link: 'https://www.adb.org/sites/default/files/project-documents/51325/51325-001-tacr-en_0.pdf'
        },
        {
          item: 'Anh Kiet-Ha Anh. ‘Hanoi strives to reduce greenhouse gas emissions by 12% in 2025’. Viet Nam Net Global. 27 July 2020. Accessed 27 June 2022.',
          link: 'https://vietnamnet.vn/en/hanoi-strives-to-reduce-greenhouse-gas-emissions-by-12-by-2025-660945.html'
        },        
        {
          item: 'Arora-Desai, Prayag (2021). Mumbai to have its own climate action plan by October. Hindustan Times, 25 June.',
          link: 'https://www.hindustantimes.com/cities/mumbai-news/mumbai-to-have-its-own-climate-action-plan-by-october-101624562450737.html'
        },   
        {
          item: 'ASEAN Climate Change and Energy Project. Thailand. Web page. Accessed on 20 September 2021.',
          link: 'https://accept.aseanenergy.org/country/thailand/'
        },
        {
          item: 'ASEAN Now. “Thailand Now Has More than 37 Million Registered Cars,” November 14, 2016.',
          link: 'https://aseannow.com/topic/953601-thailand-now-has-more-than-37-million-registered-cars/'
        },
        {
          item: 'Asian Development Bank. ‘Poverty: Thailand’. 17 May 2021. Accessed 27 June 2022.',
          link: 'https://www.adb.org/countries/thailand/poverty'
        },
        {
          item: 'bizhub. ‘Can Tho solicits investment in housing’. Viet Nam News. 16 March 2020. Accessed 27 June 2022.',
          link: 'http://bizhub.vn/property/can-tho-solicits-investment-in-housing_313962.html'
        },
        {
          item: 'C40 Cities. ‘Hanoi Metro: A Sustainable Public Transport for Densely Populated Cities’. December  2018. Accessed 27 June 2022.',
          link: 'https://www.c40.org/case-studies/hanoi-metro-a-sustainable-public-transport-for-densely-populated-cities/'
        },                        
        {
          item: 'CEIC Data (2018). Indonesia number of motor vehicles: Motorcycles: Jakarta.',
          link: 'https://www.ceicdata.com/en/indonesia/number-of-motor-vehicle-registered-motorcycles/no-of-motor-vehicles-motorcycles-jakarta'
        },
        {
          item: 'CEIC Data (2018). Indonesia number of motor vehicles: Passenger cars: Jakarta.',
          link: 'https://www.ceicdata.com/en/indonesia/number-of-motor-vehicle-registered-passenger-cars/no-of-motor-vehicles-passenger-cars-jakarta'
        },
        {
          item: 'CEIC Data (2022). South Korea Registered Motor Vehicles.',
          link: 'https://www.ceicdata.com/en/korea/number-of-registered-motor-vehicles/registered-motor-vehicles'
        },        
        {
          item: 'Chandran, Rina (2021). Thai low-cost housing plan puts slum dwellers in charge. Reuters, 16 July.',
          link: 'https://www.reuters.com/article/us-thailand-landrights-housing-trfn-idUSKBN2EM00J'
        },
        {
          item: 'Chow and Lin. “South Korea,” October 2012.',
          link: 'https://www.chowandlin.com/south-korea'
        },
        {
          item: 'City Population. “Prik,” 2020.',
          link: 'http://citypopulation.de/en/thailand/southern/songkhla/9086__prik/'
        },
        {
          item: 'Climate Action Tracker. “South Korea,” March 8, 2022.',
          link: 'https://climateactiontracker.org/countries/south-korea/'
        },                        
        {
          item: 'Economic Times (2020). India to achieve target of reducing 35 pc emissions intensity before 2030: Javadekar. 26 November.',
          link: 'https://economictimes.indiatimes.com/news/economy/policy/india-to-achieve-target-of-reducing-35-pc-emissions-intensity-before-2030-javadekar/articleshow/79430592.cms?from=mdr'
        },
        {
          item: 'Economic Times (2019). Number of vehicles on Delhi roads over 1 crore, with more than 70 lakh two wheelers: Economic survey.” 23 February.',
          link: 'https://economictimes.indiatimes.com/news/politics-and-nation/number-of-vehicles-on-delhi-roads-over-1-crore-with-more-than-70-lakh-two-wheelers-economic-survey/articleshow/68128689.cms'
        },
        {
          item: 'Etemadi, Felisa U (2000). Civil society participation in city governance in Cebu City. Environment and Urbanization vol. 12, No. 1 (2000).',
          link: 'https://doi.org/10.1177/095624780001200105'
        },  
        {
          item: 'Friedrich-Ebert-Stiftung Global (2020). Challenges for sustainable urban development in Vietnam | FES Asia. YouTube video. 3 December.',
          link: 'https://www.youtube.com/watch?v=IJMSqLYqePk'
        },  
        {
          item: 'Friedrich-Ebert-Stiftung Global (2021). Jakarta: A city on the move | Indonesia | FES Asia. YouTube video. 16 March.',
          link: 'https://youtu.be/-rU3DDKrK7s'
        },  
        {
          item: 'Friedrich-Ebert-Stiftung Global (2021). Jakarta’s future in sustainable housing | Indonesia | FES Asia. YouTube video. 16 March.',
          link: 'https://www.youtube.com/watch?v=Z5GWGnZoVL4'
        },  
        {
          item: 'Friedrich-Ebert-Stiftung Global (2020). Sustainable housing for a sustainable city | Philippines | FES Asia. YouTube video. 30 October.',
          link: 'https://www.youtube.com/watch?v=esxqaSMfoIc'
        },  
        {
          item: 'Friedrich-Ebert-Stiftung Global (2020). Transforming urban water management in India | FES Asia. YouTube video. 29 October.',
          link: 'https://www.youtube.com/watch?v=U7MkYvJGkUQ'
        },  
        {
          item: 'Friedrich Ebert Stiftung Vietnam. ‘Criteria for Sustainable Urban Communities and Cities in Vietnam.’ December 2021. Accessed 27 June 2022.',
          link: 'http://library.fes.de/pdf-files/bueros/vietnam/19164.pdf'
        },
        {
          item: 'Ginting, Ferdinand. ‘Toward a better Jakarta transportation.’ n.d. Accessed 27 June 2022.',
          link: 'https://www.unescap.org/sites/default/files/4.1%20%20Planning%20and%20development%20of%20urban%20transport%20systems%20in%20Jakarta.pdf'
        },        
        {
          item: 'Gupta, Shristi (2020). Mission “Begin again” and Mumbai’s mobility woes. Intelligent Transport, 20 November.',
          link: 'https://www.intelligenttransport.com/transport-articles/111804/mission-begin-again-and-mumbais-mobility-woes/'
        },  
        {
          item: 'C40 Cities (2018). Hanoi metro: A sustainable public transport for densely populated cities. 14 December.',
          link: 'https://www.c40.org/case_studies/hanoi-metro-a-sustainable-public-transport-for-densely-populated-cities'
        },
        {
          item: 'Explore Iloilo (2017). How to get to and around Iloilo. 11 February.',
          link: 'https://www.exploreiloilo.com/guide/iloilo-transportation/'
        },
        {
          item: '“Gini Coefficient by Country 2021.” World Population Review, 2021,',
          link: 'https://worldpopulationreview.com/country-rankings/gini-coefficient-by-country'
        },
        {
          item: '“GrEEEn City Action Plan for Songkhla and Hat Yai Municipalities.” Indonesia-Malaysia-Thailand Growth Triangle, March 2015.',
          link: 'https://www.adb.org/sites/default/files/related/41572/imt-gt-green-city-action-plan-songkhla-hat-yai-municipalities-march-2015.pdf'
        },        
        {
          item: '“Hanoi Strives to Reduce Greenhouse Gas Emissions by 12% by 2025.” Vietnam Net, 27 July 2020,',
          link: 'https://vietnamnet.vn/en/sci-tech-environment/hanoi-strives-to-reduce-greenhouse-gas-emissions-by-12-by-2025-660945.html'
        },
        {
          item: 'Hoang, Lien (2020). Vietnam aims doubling use of renewables by 2030 to slash CO2. Nikkei Asia, 7 October,',
          link: 'https://asia.nikkei.com/Spotlight/Environment/Vietnam-aims-doubling-use-of-renewables-by-2030-to-slash-CO2'
        },
        {
          item: 'Haq, Zia (2021). Joblessness grows in cities, villages: CMIE. Hindustan Times, 27 July.',
          link: 'https://www.hindustantimes.com/india-news/unemployment-rate-rises-in-both-urban-and-rural-areas-cmie-101627296519884.html'
        },  
        {
          item: 'Hollmann, Nicholas (2020). Overburdened infrastructure. Development and Cooperation, 7 January.',
          link: 'https://www.dandc.eu/en/article/there-are-far-more-cars-bangkoks-streets-its-infrastructure-can-handle'
        },  
        {
          item: '“Indonesia Unemployment Rate.” Trading Economics, 2021,',
          link: 'https://tradingeconomics.com/indonesia/unemployment-rate'
        },
        {
          item: 'IQAir. “Air Quality in Can Tho” June 25, 2022.',
          link: 'https://www.iqair.com/vietnam/thanh-pho-can-tho/can-tho'
        },
        {
          item: 'Kaushik, Malvika. “Decentralise for Net Zero Bengaluru.” Deccan Herald, March 4, 2021.',
          link: 'https://www.deccanherald.com/opinion/main-article/decentralise-for-net-zero-bengaluru-957847.html'
        },                
        {
          item: 'Knoema (2021). Transportation statistics of Thailand. Database. 17 May.',
          link: 'https://knoema.com//THNSOTS2019/transportation-statistics-of-thailand?region=1000300-lamphun'
        },  
        {
          item: 'Kwon, Yong. “The Real Cause of Seoul’s Real Estate Bubble: Economic Anxiety.” The Diplomat, August 27, 2021.',
          link: 'https://thediplomat.com/2021/08/the-real-cause-of-seouls-real-estate-bubble-economic-anxiety/'
        },      
        {
          item: 'Lee, Seonhwa. ‘How South Korea Is Managing Public Transportation under COVID-19’. IDB. 30 June 2020. Accessed 27 June 2022.',
          link: 'https://blogs.iadb.org/transporte/en/how-south-korea-is-managing-public-transportation-under-covid-19/'
        },      
        {
          item: 'Macrotrends. “Can Tho, Vietnam Metro Area Population 1950-2022” 2022.',
          link: 'https://www.macrotrends.net/cities/23355/can-tho/population'
        },      
        {
          item: 'Moudgal, Sandeep. ‘Bengaluru: Road Dust Causes Most Pollution’. The Times of India. 13 August 2018. Accessed 27 June 2022.',
          link: 'https://timesofindia.indiatimes.com/city/bengaluru/bengaluru-road-dust-causes-most-pollution/articleshow/65381884.cms'
        },                                
        {
          item: 'Nangoy, Fransiska (2021). Indonesia optimistic of reaching net zero emissions by 2060 or earlier. Reuters, 27 July.',
          link: 'https://www.reuters.com/business/environment/indonesia-optimistic-reaching-net-zero-emissions-by-2060-or-earlier-2021-07-27/'
        },  
        {
          item: 'News18 (2021). Delhi govt’s success: 72% prefer public hospitals, 69% use public transport for work travel, reveals survey. 19 January.',
          link: 'https://www.news18.com/news/india/delhi-govts-success-72-prefer-public-hospitals-69-use-public-transport-for-work-travel-reveals-survey-3311087.html'
        },  
        {
          item: 'Nguyen Huu, Duc, and Van Nguyen Ngoc. “Analysis Study of Current Transportation Status in Vietnam’s Urban Traffic and the Transition to Electric Two-Wheelers Mobility.” Sustainability 13, no. 10 (May 17, 2021).',
          link: 'https://www.mdpi.com/2071-1050/13/10/5577'
        },
        {
          item: 'Nguyen, Ngoc Ha (n.d.). Housing for low-income groups in Hanoi City: A proposal for new urban housing development. Construction and Housing Management Department, Vietnam.',
          link: 'https://www.hdm.lth.se/fileadmin/hdm/alumni/papers/hd2002/hd2002-23.pdf'
        },  
        {
          item: 'Nguyen Quy. ‘Can Tho among World’s Most Beautiful Canal Cities: Getty Images’. VnExpress International. 2 September 2019. Accessed 27 June 2022.',
          link: 'https://e.vnexpress.net/news/travel/places/can-tho-among-world-s-most-beautiful-canal-cities-getty-images-3976624.html',
        },
        {
          item: 'Park, Jong-o. ‘The 3 Major Risks of Yoon Suk-Yeol’s Economic Pledges’. Hankyoreh. 5 April 2022. Accessed 27 June 2022.',
          link: 'https://english.hani.co.kr/arti/english_edition/e_national/1037645.html',
        },
        {
          item: 'Philip, Christin Mathew. “At 50 Lakh, Bengaluru Has 2nd Most Number of Two-Wheelers.” The Times of India. January 31, 2018.',
          link: 'https://timesofindia.indiatimes.com/city/bengaluru/at-50-lakhbengaluru-has-2nd-most-number-of-two-wheelers/articleshow/62718089.cms',
        },
        {
          item: 'Philip, Christin Mathew. “Namma Metro Surges Ahead, Clocks Four-Crore Jump in Annual Ridership.” The Times of India. January 22, 2019.',
          link: 'https://timesofindia.indiatimes.com/city/bengaluru/namma-metro-surges-ahead-clocks-four-crore-jump-in-annual-ridership/articleshow/67631785.cms',
        },
        {
          item: 'Rajesh Daniel. ‘Managing Water amidst Urban Sprawl and Climate Change in Can Tho City’. SEI, 30 May 2018. Accessed 27 June 2022.',
          link: 'https://www.sei.org/featured/managing-water-amidst-urban-sprawl-climate-change-can-tho-city/',
        },                                      
        {
          item: 'Regidor, Jose Regin F (2019). Current state of transportation data and statistics in the Philippines and opportunities for improvement towards usability. National Center for Transportation Studies, 1 October.',
          link: 'https://psa.gov.ph/sites/default/files/7.5.1%20Current%20State%20of%20Transportation%20Data%20and%20Statistics%20in%20the%20Philippines%20and%20Opportunities%20for%20Improvement%20Towards%20Usability%20_0.pdf'
        },  
        {
          item: 'Reuters (2021). Philippines raises carbon emission reduction target to 75% by 2030. 16 April.',
          link: 'https://www.reuters.com/business/environment/philippines-raises-carbon-emission-reduction-target-75-by-2030-2021-04-16/'
        },
        {
          item: 'Saldanha, Leo F. ‘Fighting Climate Change without Developmental Blind-Spots’. The Hindu, 27 December 2021. Accessed 27 June 2022.',
          link: 'https://www.thehindu.com/news/cities/bangalore/fighting-climate-change-without-developmental-blind-spots/article64825294.ece',
        },          
        {
          item: 'Sen, Somit (2020). Mumbai’s vehicle density 15 times that of Maharashtra. Times of India, 6 March.',
          link: 'https//timesofindia.indiatimes.com/city/mumbai/mumbais-vehicle-density-15-times-that-of-maharashtra/articleshow/74507821.cms'
        },  
        {
          item: '“Seoul Public Transportation.” Seoul: Seoul Metropolitan Government. Accessed June 25, 2022.',
          link: 'https://www.metropolis.org/sites/default/files/seoul_public_transportation_english.pdf'
        },
        {
          item: 'Siridhara, Siradol (2021). Sustainable urban transport index for Bangkok and impacts of COVID-19 on mobility. United Nations Economic and Social Commission for Asia and the Pacific, 20 September.',
          link: 'https://www.unescap.org/sites/default/d8files/knowledge-products/SUTI_and_COVID-19_Impact_Bangkok_0.pdf'
        },
        {
          item: 'Smart Cities Dive. “Seoul: Three Pillars of Successful Urban Development.” Accessed June 25, 2022.',
          link: 'https://www.smartcitiesdive.com/ex/sustainablecitiescollective/three-pillars-successful-urban-development-seoul/138591/'
        },
        {
          item: 'Smart Cities World. ‘Seoul: A City Based on Data’. 20 March 2020. Accessed 27 June 2022.',
          link: 'https://www.smartcitiesworld.net/special-reports/special-reports/seoul-a-city-based-on-data'
        },
        {
          item: 'SMMR. “Can Tho & Mekong Region – Vietnam,” 2022.',
          link: 'https://smmr.asia/can-tho/'
        },                        
        {
          item: 'Statistical yearbook of Viet Nam 2020. Tổng cục thống kê General statistics office, 2020,',
          link: 'https://www.gso.gov.vn/wp-content/uploads/2021/07/Sach-NGTK-2020Ban-quyen.pdf'
        },
        {
          item: 'Streets of Thailand. “Transport Services in Sadao District, Songkhla Province,” 2022.',
          link: 'https://thailand-streets.openalfa.com/sadao-district/transport'
        },        
        {
          item: 'Sunstar Philippines (2017). More than half a million cars clog Cebu’s streets. 19 December.',
          link: 'https://www.sunstar.com.ph/article/410513/More-than-half-a-million-cars-clog-Cebus-streets'
        },
        {
          item: 'Sutanudjaja, Elisa. ‘Revert or readjust? Designing mobility for liveable and social cities.’ January 2022. Accessed 27 June 2022.',
          link: 'http://library.fes.de/pdf-files/bueros/vietnam/18927.pdf'
        },
        {
          item: 'Suvarna, Prajwal. “Housing for All: Who Is Left Behind?” Deccan Herald, February 26, 2022.',
          link: 'https://www.deccanherald.com/specials/insight/housing-for-all-who-is-left-behind-1085506.html'
        },
        {
          item: 'T. Trinh. ‘Can Tho Improves Adaptability to Climate Change’. Can Tho News. 30 May 2018. Accessed 27 June 2022.',
          link: 'https://baocantho.com.vn/news/can-tho-improves-adaptability-to-climate-change-a123295.html'
        },                        
        {
          item: '“Thailand Unemployment Rate.” Trading Economics, 2021,',
          link: 'https://tradingeconomics.com/thailand/unemployment-rate'
        },
        {
          item: 'The State of Affordable Housing in Mumbai. Praja, Nov. 2014,',
          link: 'https://www.praja.org/praja_docs/praja_downloads/Report%20on%20The%20State%20of%20Affordable%20Housing%20in%20Mumbai.pdf'
        },
        {
          item: '“Toward a Better Jakarta Transportation.” Jakarta. Accessed June 25, 2022.',
          link: 'https://www.unescap.org/sites/default/files/4.1%20%20Planning%20and%20development%20of%20urban%20transport%20systems%20in%20Jakarta.pdf'
        },
        { 
          item: 'Trading Economics. “South Korea Employment Rate.” Statistics Korea, 2022.',
          link: 'https://tradingeconomics.com/south-korea/employment-rate'
        },
        { 
          item: 'Vietnam News Bizhub. “Can Tho solicits investment in housing,” March 16, 2020.', 
          link: 'http://bizhub.vn/property/can-tho-solicits-investment-in-housing_313962.html' 
        },
        { 
          item: 'Vyas, Mahesh . ‘Employment increases by 8.5 million’. Centre for Monitoring Indian Economy Pvt. Ltd.. Accessed 27 June 2022.',
          link: 'https://cmie.com/kommon/bin/sr.php?kall=warticle&dt=20211001204309&msec=240'
        },
        { 
          item: 'World Population Review. “Bangalore Population 2022,” 2022.',
          link: 'https://worldpopulationreview.com/world-cities/bangalore-population' 
        },
        { 
          item: 'World Population Review. "Gini Coefficient by Country 2022," 2022.',
          link: 'https://worldpopulationreview.com/country-rankings/gini-coefficient-by-country' 
        },
        { 
          item: 'World Population Review. “Seoul Population 2022,” 2022.',
          link: 'https://worldpopulationreview.com/world-cities/seoul-population'
        },
        { 
          item: 'เทศบาลตำบลปริก (ทต.ปริก). ‘ศูนย์เรียนรู้บูรณาการเศรษฐกิจพอเพียง’. Accessed 27 June 2022.',
          link: 'http://tonprik.go.th/travel/detail/1378' 
        },                                                                       
      ],
      refCountries: [
        { 
          city: 'Bangkok', 
          list: [
            {
              "item": "ASEAN Climate Change and Energy Project. “Thailand,” n.d.",
              "link": "http://accept.aseanenergy.org/country/thailand/"
            },
            {
              "item": "Asian Development Bank Key Indicators Database. “Gini Coefficient,” 2023.",
              "link": "https://kidb.adb.org/explore?filter%5Bindicator_id%5D=2100020&filter%5Beconomy_code%5D=AFG%2CARM%2CAUS%2CAZE%2CBAN%2CBHU%2CBRU%2CCAM%2CCOO%2CFIJ%2CFSM%2CGEO%2CHKG%2CIND%2CINO%2CJPN%2CKAZ%2CKGZ%2CKIR%2CKOR%2CLAO%2CMAL%2CMLD%2CMON%2CMYA%2CNAU%2CNEP%2CNIU%2CNZL%2CPAK%2CPHI%2CPLW%2CPNG%2CPRC%2CRMI%2CSAM%2CSIN%2CSOL%2CSRI%2CTAJ%2CTAP%2CTHA%2CTIM%2CTKM%2CTON%2CTUV%2CUZB%2CVAN%2CVIE&filter%5Byear%5D=2000%2C2001%2C2002%2C2003%2C2004%2C2005%2C2006%2C2007%2C2008%2C2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021%2C2022%2C2023&grouping=indicators&showRegions=1"
            },
            {
              "item": "Chadchart. “Supporting Housing Development under the Secure Housing Concept,” n.d.",
              "link": "https://www.chadchart.com/policy/6218c1b64e43cd8b4760bcb5."
            },
            {
              "item": "Chandran, Rina. “Thai Low-Cost Housing Plan Puts Slum Dwellers in Charge.” Reuters, July 16, 2021.",
              "link": "https://www.reuters.com/article/us-thailand-landrights-housing-trfn-idUSKBN2EM00J"
            },
            {
              "item": "Community Organization Development Institute (Public Organization). “Canal Housing Development Project,” n.d.",
              "link": "https://dev-en.codi.or.th/canal-housing-development/."
            },
            {
              "item": "Hollmann, Nicholas. “Vehicle Density.” D+C, January 7, 2020.",
              "link": "https://www.dandc.eu/en/article/there-are-far-more-cars-bangkoks-streets-its-infrastructure-can-handle"
            },
            {
              "item": "Igini, Martina. “Sea Level Rise Projections: 10 Cities at Risk of Flooding.” Earth.org, June 4, 2022.",
              "link": "https://earth.org/sea-level-rise-projections/."
            },
            {
              "item": "Ritchie, Hannah, and Max Roser. “Thailand: CO2 Country Profile.” Our World in Data, n.d.",
              "link": "https://ourworldindata.org/co2/country/thailand."
            },
            {
              "item": "Siridhara, Siradol. “Sustainable Urban Transport Index for Bangkok and Impacts of COVID-19 on Mobility.” United Nations Economic and Social Commission for Asia and the Pacific, n.d.",
              "link": "https://www.unescap.org/sites/default/d8files/knowledge-products/SUTI_and_COVID-19_Impact_Bangkok_0.pdf"
            },
            {
              "item": "The Nation. “‘More Vehicles than People’: Bangkok’s Path to Liveable City Blocked,” November 27, 2022.",
              "link": "https://www.nationthailand.com/thailand/general/40022488."
            },
            {
              "item": "The Nation. “New Transport Master Plan Ready for Bangkok Metropolis,” July 28, 2023.",
              "link": "https://www.nationthailand.com/thailand/general/40029780"
            },
            {
              "item": "The Nation. “Thailand Brings Its Carbon Neutral, Net Zero Dreams Forward by Several Years,” August 30, 2022.",
              "link": "https://www.nationthailand.com/in-focus/national/40019511."
            },
            {
              "item": "Tulyasuwan, Natcha. “Private Motorized Transport, Bangkok, Thailand,” 2013.",
              "link": "https://unhabitat.org/sites/default/files/2013/06/GRHS.2013.Case_.Study_.Bangkok.Thailand.pdf"
            },
            {
              "item": "United Nations Development Programme Climate Promise. “Thailand,” November 18, 2022.",
              "link": "https://climatepromise.undp.org/what-we-do/where-we-work/thailand."
            },
            {
              "item": "World Population Review. “Bangkok Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/bangkok-population"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            }
          ]   
        },
        {
          city: 'Bengaluru',
          list: [
            {
              "item": "Dhillon, Amrit. “Ticket to Freedom: Free Bus Rides for Women Spark Joy for Millions in Karnataka.” The Guardian, June 26, 2023.",
              "link": "https://www.theguardian.com/world/2023/jun/26/ticket-to-freedom-free-bus-rides-for-women-spark-joy-for-millions-in-karnataka"
            },
            {
              "item": "Kaushik, Malvika. “Decentralise for Net Zero Bengaluru.” Deccan Herald, March 4, 2021.",
              "link": "https://www.deccanherald.com/opinion/decentralise-for-net-zero-bengaluru-957847.html"
            },
            {
              "item": "Menon, Shruti. “Climate Change: What Emission Cuts Has India Promised?” BBC News, November 7, 2022.",
              "link": "https://www.bbc.com/news/world-asia-india-58922398"
            },
            {
              "item": "Moudgal, Sandeep. “Bengaluru: Road Dust Causes Most Pollution.” The Times of India, August 13, 2018.",
              "link": "https://timesofindia.indiatimes.com/city/bengaluru/bengaluru-road-dust-causes-most-pollution/articleshow/65381884.cms"
            },
            {
              "item": "Philip, Christin Mathew. “Namma Metro Surges Ahead, Clocks Four-Crore Jump in Annual Ridership.” The Times of India, January 22, 2019.",
              "link": "https://timesofindia.indiatimes.com/city/bengaluru/namma-metro-surges-ahead-clocks-four-crore-jump-in-annual-ridership/articleshow/67631785.cms"
            },
            {
              "item": "Prasher, Garima. “What’s the Hurry? No. of Cars: 22.86 Lakh 2-Wheelers: 71.80 Lakh.” Bangalore Mirror, December 27, 2022.",
              "link": "https://bangaloremirror.indiatimes.com/bangalore/others/whats-the-hurryno-of-cars-22-86-lakh2-wheelers-71-80-lakh/articleshow/96526613.cms"
            },
            {
              "item": "Suvarna, Prajwal. “Housing for All: Who Is Left Behind?” Deccan Herald, February 27, 2022.",
              "link": "https://www.deccanherald.com/india/housing-for-all-who-is-left-behind-1085506.html"
            },
            {
              "item": "World Population Review. “Bangalore Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/bangalore-population"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Gini Coefficient by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/gini-coefficient-by-country"
            }
          ]
        },        
        {
          city: 'Can Tho',
          list: [
            {
              "item": "Daniel, Rajesh. “Managing Water amidst Urban Sprawl and Climate Change in Can Tho City.” Stockholm Environment Institute, May 30, 2018.",
              "link": "https://www.sei.org/featured/managing-water-amidst-urban-sprawl-climate-change-can-tho-city/"
            },
            {
              "item": "General Statistics Office. “The Trend of Inequality in Income Distribution in Vietnam 2016-2020 Period,” n.d.",
              "link": "https://www.gso.gov.vn/en/data-and-statistics/2021/06/the-trend-of-inequality-in-income-distribution-in-vietnam-2016-2020-period/#:~:text=In%202016%2C%20the%20GINI%20coefficient,is%200.408%20and%200.373%20respectively"
            },
            {
              "item": "Hoang, Lien. “Vietnam Aims Doubling Use of Renewables by 2030 to Slash CO2.” Nikkei Asia, October 7, 2020.",
              "link": "https://asia.nikkei.com/Spotlight/Environment/Vietnam-aims-doubling-use-of-renewables-by-2030-to-slash-CO2"
            },
            {
              "item": "Long, Cuu. “Mekong Delta Capital Has Serious Shortage of Parking Space.” VnExpress International, December 13, 2022.",
              "link": "https://e.vnexpress.net/news/news/mekong-delta-capital-has-serious-shortage-of-parking-space-4547253.html"
            },
            {
              "item": "Macrotrends. “Can Tho, Vietnam Metro Area Population 1950-2023,” 2023.",
              "link": "https://www.macrotrends.net/cities/23355/can-tho/population"
            },
            {
              "item": "Sustainable Design of Urban Mobility in Middle-Sized Metropolitan Regions. “Can Tho & Mekong Region – Vietnam,” 2023.",
              "link": "https://smmr.asia/can-tho/"
            },
            {
              "item": "Viet Nam News. “Can Tho solicits investment in housing,” March 16, 2020.",
              "link": "http://bizhub.vn/property/can-tho-solicits-investment-in-housing_313962.html"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            }
          ]
        },
        {
          city: 'Cebu City',
          list: [
            {
              "item": "ASEAN Stats Data Portal. “Total Number of Registered Road Motor Vehicles (in Thousand),” 2021.",
              "link": "https://data.aseanstats.org/indicator/ASE.TRP.ROD.B.005"
            },
            {
              "item": "Bunachita, Jose Santino S. “Cebu Losing P1.1 B Daily to Traffic Jams.” Inquirer, April 5, 2018.",
              "link": "https://newsinfo.inquirer.net/980203/cebu-losing-p1-1-b-daily-to-traffic-jams."
            },
            {
              "item": "Etemadi, Felisa U. “Civil Society Participation in City Governance in Cebu City.” Environment and Urbanization 12, no. 1 (April 1, 2000): 57–72.",
              "link": "https://doi.org/10.1177/095624780001200105"
            },
            {
              "item": "Philippine Daily Inquirer. “Cebu City to Give River Settlers ‘Safer’ Homes,” January 2, 2023.",
              "link": "https://newsinfo.inquirer.net/1711341/cebu-city-to-give-river-settlers-safer-homes"
            },
            {
              "item": "Reuters. “Philippines Raises Carbon Emission Reduction Target to 75% by 2030,” April 16, 2021.",
              "link": "https://www.reuters.com/business/environment/philippines-raises-carbon-emission-reduction-target-75-by-2030-2021-04-16/"
            },
            {
              "item": "Sitchon, John. “Cebu City Needs Housing for 20,000 Informal Settler Families.” Rappler, October 7, 2022.",
              "link": "https://www.rappler.com/nation/visayas/cebu-city-housing-needs-informal-settlers/"
            },
            {
              "item": "Sitchon, John. “Cebu City: Too Many Private Vehicles, Too Few Public Transport.” Rappler, September 26, 2022.",
              "link": "https://www.rappler.com/nation/visayas/cebu-city-too-many-private-vehicles-too-few-public-transport/"
            },
            {
              "item": "World Bank Open Data. “Gini Index - Philippines,” 2021.",
              "link": "https://data.worldbank.org"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Cebu City Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/cebu-city-population"
            }
          ]
        },
        {
          city: 'Delhi',
          list: [
            {
              "item": "Macrotrends. “Delhi, India Metro Area Population 1950-2023,” 2023.",
              "link": "https://www.macrotrends.net/cities/21228/delhi/population"
            },
            {
              "item": "News18. “Delhi Govt’s Success: 72% Prefer Public Hospitals, 69% Use Public Transport for Work Travel, Reveals Survey,” January 19, 2021.",
              "link": "https://www.news18.com/news/india/delhi-govts-success-72-prefer-public-hospitals-69-use-public-transport-for-work-travel-reveals-survey-3311087.html"
            },
            {
              "item": "Singh, Sarita Chaganti. “India Succeeds in Reducing Emissions Rate by 33% over 14 Years - Sources.” Reuters, August 9, 2023.",
              "link": "https://www.reuters.com/world/india/india-succeeds-reducing-emissions-rate-by-33-over-14-years-sources-2023-08-09/"
            },
            {
              "item": "Sivam, Alpana. “Housing Supply in Delhi.” Cities 20, no. 2 (April 2003): 135–41.",
              "link": "https://doi.org/10.1016/S0264-2751(02)00121-X"
            },
            {
              "item": "Sun, Shangliao. “Number of Private Cars Registered in Delhi, India between 1988 and 2021.” Statista, January 4, 2023.",
              "link": "https://www.statista.com/statistics/1073315/india-registered-number-of-private-cars-in-delhi/"
            },
            {
              "item": "The Economic Times. “35% Drop in Total Vehicles on Delhi Roads since Ban on Overage Automobiles: Economic Survey,” March 20, 2023.",
              "link": "https://economictimes.indiatimes.com/news/india/35-drop-in-total-vehicles-on-delhi-roads-since-ban-on-overage-automobiles-economic-survey/articleshow/98824753.cms"
            },
            {
              "item": "Tiseo, Ian. “Emissions in India - Statistics & Facts.” Statista, May 5, 2023.",
              "link": "https://www.statista.com/topics/8881/emissions-in-india/"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Gini Coefficient by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/gini-coefficient-by-country"
            }
          ]
        },
        {
          city: 'Hanoi',
          list: [
            {
              "item": "Anh, Phan. “Vietnam Loses Billions to Traffic, Needs Solutions: World Bank.” VnExpress International, December 20, 2022.",
              "link": "https://e.vnexpress.net/news/news/hanoi-loses-1-2b-every-year-to-traffic-jams-4550619.html"
            },
            {
              "item": "General Statistics Office. “The Trend of Inequality in Income Distribution in Vietnam 2016-2020 Period,” n.d.",
              "link": "https://www.gso.gov.vn/en/data-and-statistics/2021/06/the-trend-of-inequality-in-income-distribution-in-vietnam-2016-2020-period/#:~:text=In%202016%2C%20the%20GINI%20coefficient,is%200.408%20and%200.373%20respectively"
            },
            {
              "item": "Kiet, Anh. “Hanoi to Pilot Sharing Public Bicycle in Downtown Districts.” Hanoi Times, March 17, 2022.",
              "link": "https://hanoitimes.vn/hanoi-to-pilot-sharing-public-bicycle-in-downtown-districts-320257.html"
            },
            {
              "item": "Labbé, Danielle. “Urban Transition in Hanoi: Huge Challenges Ahead.” Trends in Southeast Asia. Singapore: Yusof Ishak Institute, 2021.",
              "link": "https://www.iseas.edu.sg/wp-content/uploads/2020/12/TRS2_21.pdf"
            },
            {
              "item": "Nguyen, Ngoc Ha. “Housing for Low-Income Groups in Hanoi City,” n.d.",
              "link": "https://www.hdm.lth.se/fileadmin/hdm/alumni/papers/hd2002/hd2002-23.pdf"
            },
            {
              "item": "Tuan, Viet. “Gov’t Pushes for Private Vehicle Restriction in Big Cities.” VnExpress International, September 24, 2023.",
              "link": "https://e.vnexpress.net/news/news/traffic/gov-t-pushes-for-private-vehicle-restriction-in-big-cities-4657010.html"
            },
            {
              "item": "VietNamNet Global. “Hanoi Strives to Reduce Greenhouse Gas Emissions by 12% by 2025,” July 27, 2020.",
              "link": "https://vietnamnet.vn/en/hanoi-strives-to-reduce-greenhouse-gas-emissions-by-12-by-2025-660945.html"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Hanoi Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/hanoi-population"
            }
          ]
        },
        {
          city: 'Iloilo City',
          list: [
            {
              "item": "Explore Iloilo. “How to Get to and Around Iloilo,” February 11, 2017.",
              "link": "https://www.exploreiloilo.com/guide/iloilo-transportation/"
            },
            {
              "item": "Panay News. “Not Enough Vehicle Inspection Centers,” February 1, 2021.",
              "link": "https://www.panaynews.net/not-enough-vehicle-inspection-centers/"
            },
            {
              "item": "Reuters. “Philippines Raises Carbon Emission Reduction Target to 75% by 2030,” April 16, 2021.",
              "link": "https://www.reuters.com/business/environment/philippines-raises-carbon-emission-reduction-target-75-by-2030-2021-04-16/"
            },
            {
              "item": "World Bank Open Data. “Gini Index - Philippines,” 2021.",
              "link": "https://data.worldbank.org"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Iloilo City Population 2023.” Accessed November 3, 2023.",
              "link": "https://worldpopulationreview.com/world-cities/iloilo-city-population"
            }
          ]
        },   
        {
          city: 'Jakarta',
          list: [
            {
              "item": "Ginting, Ferdinand. “Toward A Better Jakarta Transportation.” n.d.",
              "link": "https://www.unescap.org/sites/default/files/4.1%20%20Planning%20and%20development%20of%20urban%20transport%20systems%20in%20Jakarta.pdf"
            },
            {
              "item": "Jakarta’s Future in Sustainable Housing | Indonesia | FES Asia. Video. Indonesia, 2021.",
              "link": "https://www.youtube.com/watch?v=Z5GWGnZoVL4"
            },
            {
              "item": "Nangoy, Fransiska. “Indonesia Optimistic of Reaching Net Zero Emissions by 2060 or Earlier.” Reuters, July 27, 2021.",
              "link": "https://www.reuters.com/business/environment/indonesia-optimistic-reaching-net-zero-emissions-by-2060-or-earlier-2021-07-27/"
            },
            {
              "item": "Suhanda, Nopriyanto Hady, and Viddy Firmandiaz. “Addressing Inequality and Urban Segregation in Jakarta.” The Jakarta Post, June 17, 2023.",
              "link": "https://www.thejakartapost.com/opinion/2023/06/17/addressing-inequality-and-urban-segregation-in-jakarta.html"
            },
            {
              "item": "Sutanudjaja, Elisa. “Revert or Readjust? Designing Mobility for Liveable and Social Cities.” Jakarta: Friedrich-Ebert-Stiftung, January 2022.",
              "link": "https://library.fes.de/pdf-files/bueros/vietnam/18927.pdf"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Jakarta Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/jakarta-population"
            }
          ]
        },
        {
          "city": "Lamphun",
          "list": [
            {
              "item": "ASEAN Climate Change and Energy Project. “Thailand,” n.d.",
              "link": "http://accept.aseanenergy.org/country/thailand/"
            },
            {
              "item": "Asian Development Bank Key Indicators Database. “Gini Coefficient,” 2023.",
              "link": "https://kidb.adb.org/explore?filter%5Bindicator_id%5D=2100020&filter%5Beconomy_code%5D=AFG%2CARM%2CAUS%2CAZE%2CBAN%2CBHU%2CBRU%2CCAM%2CCOO%2CFIJ%2CFSM%2CGEO%2CHKG%2CIND%2CINO%2CJPN%2CKAZ%2CKGZ%2CKIR%2CKOR%2CLAO%2CMAL%2CMLD%2CMON%2CMYA%2CNAU%2CNEP%2CNIU%2CNZL%2CPAK%2CPHI%2CPLW%2CPNG%2CPRC%2CRMI%2CSAM%2CSIN%2CSOL%2CSRI%2CTAJ%2CTAP%2CTHA%2CTIM%2CTKM%2CTON%2CTUV%2CUZB%2CVAN%2CVIE&filter%5Byear%5D=2000%2C2001%2C2002%2C2003%2C2004%2C2005%2C2006%2C2007%2C2008%2C2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021%2C2022%2C2023&grouping=indicators&showRegions=1"
            },
            {
              "item": "Community Organization Development Institute (Public Organization). “Baan Mankong Rural,” n.d.",
              "link": "https://en.codi.or.th/baan-mankong-rural/."
            },
            {
              "item": "Knoema. “Transportation Statistics of Thailand,” n.d.",
              "link": "https://knoema.com//THNSOTS2019/transportation-statistics-of-thailand?region=1000300-lamphun"
            },
            {
              "item": "Techasa, Monchai. “Community Organization Development Institute discusses with Lamphun Governor, organizing a forum to solve the problem of low-income housing.” Chiang Mai News, November 1, 2016.",
              "link": "https://www.chiangmainews.co.th/page/archives/534052."
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Lamphun Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/lamphun-population"
            }
          ]
        },
        {
          city: 'Mumbai',
          list: [
            {
              "item": "Gupta, Shristi, and Vignesh P. “Mission ‘Begin Again’ and Mumbai’s Mobility Woes.” Intelligent Transport, November 20, 2020.",
              "link": "https://www.intelligenttransport.com/transport-articles/111804/mission-begin-again-and-mumbais-mobility-woes/"
            },
            {
              "item": "Menon, Shruti. “Climate Change: What Emission Cuts Has India Promised?” BBC News, November 7, 2022.",
              "link": "https://www.bbc.com/news/world-asia-india-58922398"
            },
            {
              "item": "Pethe, Abhay, Rashmi Sharma, and Dhaval Desai. “The Pathway to Affordable Housing in Urban India: A Case Study of Mumbai.” ORF Occasional Paper No. 401. Observer Research Foundation, April 2023.",
              "link": "https://www.orfonline.org/research/the-pathway-to-affordable-housing-in-urban-india/"
            },
            {
              "item": "Sen, Somit. “At 14 Lakh, There Are 700 LMVs/Km in Mumbai: Economic Survey.” The Times of India, March 12, 2023.",
              "link": "https://timesofindia.indiatimes.com/at-14-lakh-there-are-700-lmvs/km-in-mumbai-eco-survey/articleshow/98576335.cms?from=mdr"
            },
            {
              "item": "Tiseo, Ian. “Emissions in India - Statistics & Facts.” Statista, May 5, 2023.",
              "link": "https://www.statista.com/topics/8881/emissions-in-india/"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Gini Coefficient by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/gini-coefficient-by-country"
            },
            {
              "item": "World Population Review. “Mumbai Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/mumbai-population"
            }
          ]
        },
        {
          city: "Seoul",
          "list": [
            {
              "item": "Asian Development Bank Key Indicators Database. “Gini Coefficient,” 2023.",
              "link": "https://kidb.adb.org/explore?filter%5Bindicator_id%5D=2100020&filter%5Beconomy_code%5D=AFG%2CARM%2CAUS%2CAZE%2CBAN%2CBHU%2CBRU%2CCAM%2CCOO%2CFIJ%2CFSM%2CGEO%2CHKG%2CIND%2CINO%2CJPN%2CKAZ%2CKGZ%2CKIR%2CKOR%2CLAO%2CMAL%2CMLD%2CMON%2CMYA%2CNAU%2CNEP%2CNIU%2CNZL%2CPAK%2CPHI%2CPLW%2CPNG%2CPRC%2CRMI%2CSAM%2CSIN%2CSOL%2CSRI%2CTAJ%2CTAP%2CTHA%2CTIM%2CTKM%2CTON%2CTUV%2CUZB%2CVAN%2CVIE&filter%5Byear%5D=2000%2C2001%2C2002%2C2003%2C2004%2C2005%2C2006%2C2007%2C2008%2C2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021%2C2022%2C2023&grouping=indicators&showRegions=1"
            },
            {
              "item": "CEIC. “South Korea Registered Motor Vehicles,” September 2023.",
              "link": "https://www.ceicdata.com/en/korea/number-of-registered-motor-vehicles/registered-motor-vehicles"
            },
            {
              "item": "Choi, Jieun. “Painting a World in Two Square Meters.” Korea Exposé, September 1, 2018.",
              "link": "https://koreaexpose.com/painting-world-two-square-meters/"
            },
            {
              "item": "Climate Action Tracker. “South Korea,” July 17, 2023.",
              "link": "https://climateactiontracker.org/countries/south-korea/"
            },
            {
              "item": "Fennell, Matthew. “Renting a House in South Korea: Jeonse.” Asia Society: Korea, July 30, 2021.",
              "link": "https://asiasociety.org/korea/renting-house-south-korea-jeonse"
            },
            {
              "item": "Kim, Max. “In Seoul’s ‘piece Rooms,’ There’s Barely Enough Space to Lie down. Inside South Korea’s Brutal Housing Crisis.” Los Angeles Times, April 11, 2023.",
              "link": "https://www.latimes.com/world-nation/story/2023-04-11/in-seouls-piece-rooms-theres-not-even-enough-room-to-lay-down-inside-south-koreas-brutal-housing-crisis"
            },
            {
              "item": "Kwon, Yong. “The Real Cause of Seoul’s Real Estate Bubble: Economic Anxiety.” The Diplomat, August 27, 2021.",
              "link": "https://thediplomat.com/2021/08/the-real-cause-of-seouls-real-estate-bubble-economic-anxiety/"
            },
            {
              "item": "“Seoul Public Transportation.” Seoul: Seoul Metropolitan Government, n.d.",
              "link": "https://www.metropolis.org/sites/default/files/seoul_public_transportation_english.pdf"
            },
            {
              "item": "Smart Cities Dive. “Seoul: Three Pillars of Successful Urban Development,” 2012.",
              "link": "https://www.smartcitiesdive.com/ex/sustainablecitiescollective/three-pillars-successful-urban-development-seoul/138591/"
            },
            {
              "item": "World Population Review. “Carbon Footprint by Country 2023,” 2023.",
              "link": "https://worldpopulationreview.com/country-rankings/carbon-footprint-by-country"
            },
            {
              "item": "World Population Review. “Seoul Population 2023,” 2023.",
              "link": "https://worldpopulationreview.com/world-cities/seoul-population"
            }
          ]
        }
      ],      
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-chapter-1 {
  scroll-margin-top: 70px;

  .ref-chapter-1-hero {
    img {
      display: block;
      max-height: 180px;
      width: 100%;
    }
  }  

  .ref-chapter-1-content {
    padding: 96px 0;
    background: #FAFAFA;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 48px 4px;
    }
    
    .reference-list {
      p:last-child {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>